import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'vfx_staff_token';

const Ctx = createContext(null);

export function StaffAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(!!token);

  const authHeader = useCallback(
    () => (token ? { Authorization: `Bearer ${token}` } : {}),
    [token]
  );

  const applyToken = useCallback((t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
    setToken(t || null);
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function boot() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const res = await axios.get(`${API}/crm/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setStaff(res.data.staff);
      } catch {
        if (!cancelled) applyToken(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    boot();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/crm/auth/login`, { email, password });
    applyToken(res.data.token);
    setStaff(res.data.staff);
    return res.data.staff;
  };

  const logout = () => {
    applyToken(null);
    setStaff(null);
  };

  return (
    <Ctx.Provider value={{ staff, token, loading, login, logout, authHeader, API }}>
      {children}
    </Ctx.Provider>
  );
}

export function useStaffAuth() {
  const c = useContext(Ctx);
  if (!c) throw new Error('useStaffAuth must be used inside StaffAuthProvider');
  return c;
}
